module.exports = __webpack_public_path__ + "699cdef45ea2162ecbb608d7b7b7c912.MP3";